module.exports = __webpack_public_path__ + "static/media/close.887be990.svg";